var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DeviceLayout',{attrs:{"preview-data":{ name: _vm.previewNameLang, type: 'LightPushButton' },"device-icon":"light-bulb","is-preview":true},scopedSlots:_vm._u([{key:"basic-controls",fn:function(){return [_c('div',{staticClass:"light-push-button"},[_c('PushButtonMock')],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }